import { useQuery } from "@tanstack/react-query";
import { fetchAllApps } from "@/services/DataService";

export const useApps = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["apps"],
    queryFn: fetchAllApps,
    enabled: options?.enabled ?? true,
  });
};
